import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import queryStringify from 'querystringify';
import React, { Component } from 'react';

import jsonGet from '../../../util/jsonGet';

import { addCultureToParamsFromLocalStorage } from '../../../util/culture';
import ErrorBoundary from '../Core/ErrorBoundary';
import Pagination from '../Core/Pagination';
import Filter from './Filter';
import Results from './Results';

const propTypes = exact({
  apiURL: PropTypes.string.isRequired,
  noResultsMessage: PropTypes.string.isRequired,
  resultsPerPage: PropTypes.number.isRequired,
  searchQueryPrefix: PropTypes.string,
  siteId: PropTypes.number.isRequired,
  searchPlaceholderText: PropTypes.string,
});

const defaultProps = {
  searchPlaceholderText: 'Enter your search...',
};

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: null,
      query: '',
    };

    this.handleNextClick = this.handleNextClick.bind(this);
    this.handlePreviousClick = this.handlePreviousClick.bind(this);
    this.searchQuery = this.searchQuery.bind(this);
    this.searchURLParams = this.searchURLParams.bind(this);
  }

  componentDidMount() {
    this.searchURLParams();
    window.addEventListener('popstate', this.searchURLParams);
  }

  loadResults(filterOptions) {
    const options = { ...addCultureToParamsFromLocalStorage(filterOptions) };
    options.page = options.page || 1;
    options.resultsPerPage = this.props.resultsPerPage;
    options.siteId = this.props.siteId;

    if (!('query' in options)) {
      if (this.state.query) options.query = this.state.query;
    }

    if (!('query' in options)) return;

    jsonGet(this.props.apiURL, options, ({ items, totalItemCount }) => {
      const paramString = queryStringify.stringify(
        {
          query: options.query,
          page: options.page,
        },
        true
      );

      const path = window.location.pathname + paramString;
      window.history.pushState(null, null, path);

      const totalPages = Math.ceil(totalItemCount / this.props.resultsPerPage);

      this.setState({
        items,
        page: options.page,
        query: options.query,
        totalPages,
      });
    });
  }

  searchQuery(query) {
    if (query === '') return;
    this.loadResults({ query });
  }

  searchURLParams() {
    const URLArray = window.location.href.split('?');
    if (URLArray.length <= 0) return;
    const params = queryStringify.parse(URLArray[1]);
    if (!('query' in params)) return;

    this.loadResults({
      page: parseInt(params.page, 10),
      query: params.query,
      resultsPerPage: this.props.resultsPerPage,
      siteId: this.props.siteId,
    });
  }

  handleNextClick() {
    if (!(this.state.page < this.state.totalPages)) return;

    const page = this.state.page + 1;
    this.loadResults({ page });
  }

  handlePreviousClick() {
    if (!(this.state.page > 0)) return;

    const page = this.state.page - 1;
    this.loadResults({ page });
  }

  render() {
    return (
      <ErrorBoundary>
        <div className="SearchContainer">
          <Filter
            onSearch={this.searchQuery}
            searchQueryPrefix={this.props.searchQueryPrefix}
            placeholderText={this.props.searchPlaceholderText}
            query={this.state.query}
          />
          {this.state.items && (
            <Results items={this.state.items} noResultsMessage={this.props.noResultsMessage} />
          )}
          {this.state.items && this.state.totalPages > 1 && (
            <Pagination
              currentPage={this.state.page}
              handleNextClick={this.handleNextClick}
              handlePreviousClick={this.handlePreviousClick}
              totalPages={this.state.totalPages}
            />
          )}
        </div>
      </ErrorBoundary>
    );
  }
}

Search.propTypes = propTypes;
Search.defaultProps = defaultProps;

export default Search;
